import { useContext, useState } from 'react';
import * as R from 'ramda';

import WorkTemplateContext from '@atom/components/workTemplate/WorkTemplateContext';
import { Icon, IconButton } from '@atom/mui';
import {
  AddIcon,
  CategoryIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
} from '@atom/mui/icons';
import {
  doesNotHaveRolePermissions,
  ROLE_SETS,
} from '@atom/utilities/authUtilities';

import AddSchemaModal from './addSchemaModal/AddSchemaModal';
import SchemaTile from './SchemaTile';

import classes from './schemaSection.module.css';

const SchemaSection = () => {
  const { workTemplate, task } = useContext(WorkTemplateContext);

  const [expanded, setExpanded] = useState<boolean>(true);
  const [open, setOpen] = useState<boolean>(false);

  const isSectionEmpty = R.isEmpty(task.schemas);
  const totalCount = R.length(task.schemas) || 0;
  const icon = expanded ? ExpandLessIcon : ExpandMoreIcon;
  const isDisabled =
    workTemplate?.published || doesNotHaveRolePermissions(ROLE_SETS.ORG_ADMIN);

  return (
    <>
      <div className={classes.sectionContainer}>
        <Icon icon={CategoryIcon} />
        <div className={classes.sectionTitle}>Asset Type</div>
        <div className={classes.totalCount}>{totalCount}</div>
        <div className={classes.buttonsContainer}>
          {expanded && (
            <IconButton
              onClick={() => setOpen(true)}
              edge="end"
              tooltip="Add Asset"
              disabled={isDisabled}
            >
              <Icon icon={AddIcon} />
            </IconButton>
          )}
          <IconButton onClick={() => setExpanded(!expanded)} edge="end">
            <Icon icon={icon} />
          </IconButton>
        </div>
      </div>
      {expanded && (
        <div className={classes.tileList}>
          {isSectionEmpty ? (
            <div className={classes.emptySectionText}>Add Asset Type</div>
          ) : (
            <>
              {task.schemas.map(schema => (
                <SchemaTile key={schema.id} schema={schema} />
              ))}
            </>
          )}
        </div>
      )}
      <AddSchemaModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default SchemaSection;
